import Vue from 'vue';
import exchangeRateAfir from './exchange-rate-afir/exchange-rate-afir';
import store from '../common/js/vuex/store';
import exchangeRateAfirStore from '../applications/exchange-rate-afir/exchange-rate-afir-vuex';
if (!store.hasModule(['exchangeRateAfir'])) {
	store.registerModule('exchangeRateAfir', exchangeRateAfirStore);
}
Vue.component('exchange-rate-afir', exchangeRateAfir);
